// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BerthFormTabs.css */

.berth-form-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.main-content-container {
    display: flex;
    flex: 1 1;
    background: #f7fbff;
}

.berth-form-main {
    flex: 1 1;
    padding: 24px;
}

.berth-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 24px;
}

.berth-tab {
    padding: 10px 18px;
    font-weight: bold;
    color: #fff;
    border: none;
    border-radius: 6px;
    transition: background 0.3s ease;
    cursor: pointer;
}

    .berth-tab.active {
        background: #d4af37;
        color: #000;
    }

    .berth-tab:hover {
        background: #efefef;
    }

.berth-tab-content {
    padding: 24px;
    background-color: #ffffff;
    border: 1px solid #ddd;
    border-radius: 8px;
    margin-bottom: 30px;
}

.berth-form-controls {
    display: flex;
    justify-content: flex-start;
    gap: 16px;
    padding-bottom: 30px;
}

.control-btn {
    padding: 10px 20px;
    font-weight: 600;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
}

.back-btn {
    background-color: #d3d3d3;
    color: #333;
}

.save-btn {
    background-color: #a020f0;
    color: white;
}

.next-btn {
    background-color: #007bff;
    color: white;
}
.review-container {
    padding: 24px;
    background: #f4f4f4;
    border-radius: 8px;
}

.review-section {
    margin-bottom: 24px;
}

    .review-section h3 {
        font-size: 1.2rem;
        margin-bottom: 12px;
        color: #333;
    }

.review-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 16px;
    color: #444;
}

    .review-grid div {
        background: #fff;
        padding: 12px 16px;
        border-radius: 6px;
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);
    }
`, "",{"version":3,"sources":["webpack://./src/pages/demo/PortCall/BerthFormTabs.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAO;IACP,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;AACnB;;IAEI;QACI,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;AAEJ;IACI,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;IAEI;QACI,iBAAiB;QACjB,mBAAmB;QACnB,WAAW;IACf;;AAEJ;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,WAAW;AACf;;IAEI;QACI,gBAAgB;QAChB,kBAAkB;QAClB,kBAAkB;QAClB,sCAAsC;IAC1C","sourcesContent":["/* BerthFormTabs.css */\n\n.berth-form-wrapper {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n}\n\n.main-content-container {\n    display: flex;\n    flex: 1;\n    background: #f7fbff;\n}\n\n.berth-form-main {\n    flex: 1;\n    padding: 24px;\n}\n\n.berth-tabs {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-bottom: 24px;\n}\n\n.berth-tab {\n    padding: 10px 18px;\n    font-weight: bold;\n    color: #fff;\n    border: none;\n    border-radius: 6px;\n    transition: background 0.3s ease;\n    cursor: pointer;\n}\n\n    .berth-tab.active {\n        background: #d4af37;\n        color: #000;\n    }\n\n    .berth-tab:hover {\n        background: #efefef;\n    }\n\n.berth-tab-content {\n    padding: 24px;\n    background-color: #ffffff;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    margin-bottom: 30px;\n}\n\n.berth-form-controls {\n    display: flex;\n    justify-content: flex-start;\n    gap: 16px;\n    padding-bottom: 30px;\n}\n\n.control-btn {\n    padding: 10px 20px;\n    font-weight: 600;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.back-btn {\n    background-color: #d3d3d3;\n    color: #333;\n}\n\n.save-btn {\n    background-color: #a020f0;\n    color: white;\n}\n\n.next-btn {\n    background-color: #007bff;\n    color: white;\n}\n.review-container {\n    padding: 24px;\n    background: #f4f4f4;\n    border-radius: 8px;\n}\n\n.review-section {\n    margin-bottom: 24px;\n}\n\n    .review-section h3 {\n        font-size: 1.2rem;\n        margin-bottom: 12px;\n        color: #333;\n    }\n\n.review-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n    gap: 16px;\n    color: #444;\n}\n\n    .review-grid div {\n        background: #fff;\n        padding: 12px 16px;\n        border-radius: 6px;\n        box-shadow: 0 0 3px rgba(0, 0, 0, 0.1);\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
